import { useEffect, useState } from "react";
import login1 from "../../assets/gm-login1.png";
import login2 from "../../assets/gm-login2.png";
import login3 from "../../assets/gm-login3.png";

const Title1 = "Descubre el potencial oculto de tus colaboradores";
const Title2 = "Escoge a la persona idónea";
const Title3 = "Aumenta el bienestar de tus colaboradores";
const Subtitle1 =
  "Identifica y cierra las brechas en sus niveles de consciencia con assessments personalizados.";
const Subtitle2 =
  "A través de nuestras evaluaciones, identifica de forma certera a la persona que mejor se adecúa al perfil y nivel de conciencia que buscas. ";
const Subtitle3 =
  "A través de la ciencia aplicada, GrowMe les ofrece una comprensión profunda de sí mismo y los acompaña en el camino del crecimiento personal.";

const SliderLogin = () => {
  const [currentSelect, setCurrentSelect] = useState("slider-1");

  useEffect(() => {
    const interval = setInterval(() => {
      if (currentSelect === "slider-1") setCurrentSelect("slider-2");
      else if (currentSelect === "slider-2") setCurrentSelect("slider-3");
      else setCurrentSelect("slider-1");
    }, 6000);

    return () => clearInterval(interval);
  }, [currentSelect]);

  return (
    <div className="gm-slider-component-container">
      <section className="gm-img-container">
        <div
          id="slider-1"
          className={currentSelect === "slider-1" ? "image-active" : "image"}
        >
          <img src={login1} alt="growme-login-img1" />
          <article>
            <span>{Title1}</span>
            <span>{Subtitle1}</span>
          </article>
        </div>
        <div
          id="slider-2"
          className={currentSelect === "slider-2" ? "image-active" : "image"}
        >
          <img src={login2} alt="growme-login-img2" />
          <article>
            <span>{Title2}</span>
            <span>{Subtitle2}</span>
          </article>
        </div>
        <div
          id="slider-3"
          className={currentSelect === "slider-3" ? "image-active" : "image"}
        >
          <img src={login3} alt="growme-login-img3" />
          <article>
            <span>{Title3}</span>
            <span>{Subtitle3}</span>
          </article>
        </div>
      </section>
      <section className="gm-buttons-container">
        <button
        className={currentSelect === "slider-1" ? "gm-button-active" : "gm-button-slider"}
          onClick={() => {
            setCurrentSelect("slider-1");
          }}
        ></button>
        <button
        className={currentSelect === "slider-2" ? "gm-button-active" : "gm-button-slider"}
          onClick={() => {
            setCurrentSelect("slider-2");
          }}
        ></button>
        <button
        className={currentSelect === "slider-3" ? "gm-button-active" : "gm-button-slider"}
          onClick={() => {
            setCurrentSelect("slider-3");
          }}
        ></button>
      </section>
    </div>
  );
};

export default SliderLogin;
